import React from 'react';

const AboutSection = () => {
  return (
    <>
      <section className="about-section" id="about">
        <div className="container">
          <div className="meet-barber-section">
            <div className="barber-image-container">
              <img 
                src={`${process.env.PUBLIC_URL}/JennySelfie.jpg`} 
                alt="Jenny Wang - Master Hair Stylist and Makeup Artist"
                className="barber-image"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/500x600/f8f8f8/666666?text=Barber+Profile';
                }}
              />
            </div>
            <div className="barber-content">
              <div className="barber-header">
                <span className="header-line"></span>
                <h2 className="meet-barber-title">MEET YOUR BARBER</h2>
                <span className="header-line"></span>
              </div>
              
              <h1 className="barber-name">Jenny Wang</h1>
              
              <div className="barber-title-wrapper">
                <span className="title-line"></span>
                <p className="barber-title">Master Hair Stylist and Makeup Artist</p>
                <span className="title-line"></span>
              </div>
              
              <p className="barber-quote">
                "Precision, style, and confidence — every cut tailored to you."
              </p>
              
              <div className="barber-info">
                <div className="info-section">
                  <h3 className="info-heading">Experience</h3>
                  <ul className="info-list">
                    <li>20+ years of professional barbering and makeup artistry</li>
                    <li>Trained in classic & modern styles for both men and women</li>
                  </ul>
                </div>
                
                <div className="info-divider"></div>
                
                <div className="info-section">
                  <h3 className="info-heading">Specialties</h3>
                  <ul className="info-list specialties-list">
                    <li>Hair Styling & Cutting</li>
                    <li>Makeup Application</li>
                    <li>Hair Color & Highlighting</li>
                    <li>Hair Perming</li>
                    <li>Hair Straightening & Relaxing</li>
                    <li>Hair Extensions (Human Hair, Synthetic Hair, etc.)</li>
                    <li>Hair Removal (Waxing, Threading, etc.)</li>
                  </ul>
                </div>
                
                <div className="info-divider"></div>
                
                <div className="info-section">
                  <h3 className="info-heading">About Jenny</h3>
                  <p className="about-text">
                    Jenny believes a great haircut and makeup application is more than a service—it's an experience. 
                    She takes time to understand each client's style and delivers clean, precise cuts and natural, 
                    precise cuts and makeup that enhance confidence and personal expression.
                  </p>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSection;



